




































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { IState } from "@/store";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";
import { IWalletBalance } from "@/models/wallets";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import { IClient } from "@/models/clients";
import Context from "@/mixins/context";
import PaymentStatusMixin from "@/mixins/paymentStatusMixin";
import { IAccount } from "@/models/accounts";
import _ from "@/boot/lodash";

@Component({
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/balanceScope`](this.accountId);
      },
      wallet(state, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class WalletBalance extends Mixins(
  RequestPromises,
  CurrenciesStore,
  PaymentStatusMixin,
  Context
) {
  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: false })
  public canTopUpAccountCredit!: boolean;

  public wallet!: IWalletBalance;
  public dataScope!: string;
  public dataModule = DataModules.WALLETS;
  // Data
  public isLoading = false;
  public isReloading = false;
  public requestError = false;
  public canSeeWallet = this.$userCan("wallet_admin_get_balance");

  public async created() {
    if (!this.canSeeWallet) {
      return;
    }
    this.isLoading = true;
    this.getBalance();
    this.$bus.$on("autopay-wallet-success", this.reloadData);
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: this.dataModule,
      scope: this.dataScope,
      vm: this
    });
    this.$bus.$off("autopay-wallet-success", this.reloadData);
  }

  public get accountId(): IAccount["id"] {
    return this.client.accounts[0].id;
  }

  public get balances() {
    if (_.isEmpty(this.wallet)) {
      return [];
    }
    const balances: any[] = [];
    _.forEach(this.wallet.total, (balance, index) => {
      if (!balance.amount_converted) {
        return;
      }
      balances.push({ ...balance, code: index });
    });

    return balances;
  }

  // Methods

  public reloadData() {
    this.isReloading = true;
    this.getBalance();
  }

  public async topUp(wallet) {
    const topUpModal = await this.$store.dispatch(
      `data/${DataModules.WALLETS}/openTopUpModal`,
      {
        props: {
          client: this.client,
          currencyId: wallet.currency.id
        },
        events: {
          success: () => {
            this.getBalance();
            this.$emit("refresh-payments");
            topUpModal.close();
          }
        }
      }
    );
  }

  public async adjustBalance(walletBalance) {
    this.$store.dispatch(
      `data/${DataModules.WALLETS}/openAdjustWalletBalanceModal`,
      {
        props: {
          client: this.client,
          amount: walletBalance.amount,
          currencyCode: walletBalance.code
        },
        events: {
          success: () => {
            this.getBalance();
            this.$emit("refresh-payments");
          }
        }
      }
    );
  }

  public async refund(wallet) {
    const modal = await this.$store.dispatch(
      `data/${DataModules.WALLETS}/openRefundFromWalletModal`,
      {
        props: {
          client: this.client,
          currencyId: wallet.currency.id
        },
        events: {
          success: () => {
            this.getBalance();
            this.$emit("refresh-payments");
            modal.close();
          }
        }
      }
    );
  }

  public async getBalance() {
    this.isLoading = true;
    this.requestError = false;
    try {
      await this.$store.dispatch(`data/${this.dataModule}/balance`, {
        scope: this.dataScope,
        ignoreStored: true,
        accountId: this.accountId,
        vm: this
      });
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }
}
